import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField } from '@mui/material';

const defaultRows = [
  { name: '' },
  { name: '' },
  { name: '' },
  { name: '' },
  { name: '' },
  { name: 'Setting' },
  { name: 'Polish' },
  { name: 'Cutting' },
  { name: 'Galai' },
  { name: '' },
];

const columns = [
  'Name',
  'P. Balance',
  'New',
  'Balance',
  'Work',
  'Wastage',
  'Net Balance',
];

const TransactionWorkTable = ({ rows = defaultRows, onChange }) => {
  // Ensure at least 10 rows
  const filledRows = [
    ...rows,
    ...Array(Math.max(0, 10 - rows.length)).fill().map(() => ({ name: '' }))
  ].slice(0, 10);

  // Helper to parse numbers safely
  const num = v => isNaN(Number(v)) ? 0 : Number(v);

  return (
    <TableContainer component={Paper} sx={{ mb: 2 }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            {columns.map(col => (
              <TableCell key={col} sx={{ fontWeight: 600 }}>{col}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {filledRows.map((row, rowIdx) => {
            // Calculate Balance and Net Balance
            const pBalance = num(row.pBalance);
            const newVal = num(row.new);
            const work = num(row.work);
            const wastage = num(row.wastage);
            const balance = pBalance + newVal;
            const netBalance = balance - work - wastage;
            return (
              <TableRow key={rowIdx}>
                {columns.map((col, colIdx) => {
                  if (col === 'Name') {
                    return (
                      <TableCell key={colIdx}>
                        <TextField
                          value={row.name || ''}
                          onChange={e => onChange && onChange(rowIdx, 'name', e.target.value)}
                          size="small"
                          variant="standard"
                          fullWidth
                          disabled={['Setting','Polish','Cutting','Galai'].includes(row.name)}
                        />
                      </TableCell>
                    );
                  } else if (col === 'Balance') {
                    return (
                      <TableCell key={colIdx}>
                        <TextField
                          value={balance}
                          size="small"
                          variant="standard"
                          fullWidth
                          InputProps={{ readOnly: true }}
                        />
                      </TableCell>
                    );
                  } else if (col === 'Net Balance') {
                    return (
                      <TableCell key={colIdx}>
                        <TextField
                          value={netBalance}
                          size="small"
                          variant="standard"
                          fullWidth
                          InputProps={{ readOnly: true }}
                        />
                      </TableCell>
                    );
                  } else {
                    // Editable fields: P. Balance, New, Work, Wastage
                    return (
                      <TableCell key={colIdx}>
                        <TextField
                          value={col === 'P. Balance' ? row.pBalance || '' : row[col.toLowerCase().replace(/\s/g, '')] || ''}
                          onChange={e => onChange && onChange(rowIdx, col === 'P. Balance' ? 'pBalance' : col.toLowerCase().replace(/\s/g, ''), e.target.value)}
                          size="small"
                          variant="standard"
                          fullWidth
                        />
                      </TableCell>
                    );
                  }
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TransactionWorkTable; 